import type { ImpersonationTarget } from './model';

export const fixtureImpersonationTargets: ImpersonationTarget[] = [
  {
    identityId: 'identity-02',
    personId: 'person-02',
    workerId: '02',
    displayName: '우디(박진우)',
    workerNumber: 'A0104',
    organization: 'Engineering Division',
  },
  {
    identityId: 'identity-04',
    personId: 'person-04',
    workerId: '04',
    displayName: '이수연',
    workerNumber: 'A0188',
    organization: 'Design Team',
  },
  {
    identityId: 'identity-05',
    personId: 'person-05',
    workerId: '05',
    displayName: '한도윤',
    workerNumber: 'A0203',
    organization: 'Business Division',
  },
];
